module.exports = __webpack_public_path__ + "img/sgp_rbfc.498ca978.jpg";